<template>
  <div class="pb-tab-panal-black">
    <ul ref="slider_parent" class="pb-tab-panal">
      <li
        ref="pb-tab-panal-item"
        :class="{ active: active === index, 'pb-tab-panal-item': true }"
        v-for="(item, index) in items"
        :key="index"
        @click="(ev) => clickPanal(ev.target, item.value, index)"
        v-html="item.label || '제목없음'"
      />
    </ul>
    <div class="pb-tab-panal-slider">
      <div
        class="pb-tab-panal-slider__action"
        :style="`left: ${left}px; width: ${width}px`"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PbTabPanal",
  data: () => ({
    localActive: 0,
    tempStorage: {
      left: [],
      width: [],
    },
    left: 0,
    width: 0,
  }),
  props: {
    items: Array,
    active: [Number, String],
  },
  methods: {
    clickPanal(el, value, index) {
      this.runSlider(index);
      this.$emit("action", value, index);
    },

    runSlider(index) {
      const left =
        this.$refs.slider_parent.offsetLeft + this.tempStorage.left[index];
      this.localActive = index;
      this.left = left;
      this.width = this.tempStorage.width[index];
    },

    save(panal) {
      for (let element of panal) {
        const { clientWidth, offsetLeft } = element;
        this.tempStorage.width.push(clientWidth);
        this.tempStorage.left.push(offsetLeft);
      }
    },

    resizeEvent() {
      if (this.$refs["pb-tab-panal-item"].length > 0) {
        this.save(this.$refs["pb-tab-panal-item"]);
        this.$refs["pb-tab-panal-item"].forEach((el, index) => {
          if (/(active)/.test(el.className)) {
            this.runSlider(index);
          }
        });
      }
    },
  },
  mounted() {
    this.resizeEvent();
    window.addEventListener("resize", this.resizeEvent);
  },

  destroyed() {
    window.removeEventListener("resize", this.resizeEvent);
  },
};
</script>
<style lang="scss">
@import "~styles/color";

.pb-tab-panal {
  position: relative;
  display: flex;
  font-size: 1.5rem;

  li {
    padding: 0 1.8rem;
    height: calc(1.6rem + 1.5em + 2px);
    line-height: calc(1.6rem + 1.5em + 2px);
    border-bottom: 2px solid transparent;
    cursor: pointer;
  }

  &-slider {
    width: 100%;
    height: 1px;
    background-color: $disabled;

    &__action {
      position: absolute;
      background-color: $black;
      height: 1px;
      transition: all 0.3s;
    }
  }
}
</style>
